<template>
  <div class="container">
    <van-nav-bar title="设备激活" left-text="" left-arrow @click-left="onClickLeft" />
    <div class="menu">
      <van-field readonly label="设备编号" :value="mainNo" placeholder="" />
      <van-field readonly clickable label="选择项目" :value="communityName" placeholder="请选择设备安装的项目" @click="showPicker" />
      <van-field v-model="location" label="设备位置" type="textarea" maxlength="30" rows="2" autosize show-word-limit
        placeholder="请输入设备位置" />
    </div>
    <van-popup v-model="showPopup" round position="bottom">
      <van-picker show-toolbar :columns="columns" value-key="name" @cancel="showPopup = false" @confirm="onConfirm"
        @change="onChange" />
    </van-popup>
    <div class="btnbox">
      <van-button type="info" size="large" @click="setQRInfo" :disabled="!communityId">下一步</van-button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js';
import { NavBar, Icon, Toast, Loading, Picker, Field, Popup, Button } from 'vant';
export default {
  data() {
    return {
      showPopup: false,
      mainNo: '',
      location: '',
      communityName: '',
      communityId: '',
      columns: [],
      cityList: [],
      communityList: [],
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Button.name]: Button,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
  },
  methods: {
    changePage(url) {
      this.$router.push({ path: url + ".html", query: { mainNo: this.mainNo, communityId: this.communityId, location: this.location } })
    },
    showPicker() {
      this.showPopup = true;
      this.columns = [
        // 第一列
        {
          values: this.cityList,
          defaultIndex: 0,
        },
        // 第二列
        {
          values: this.communityList,
          defaultIndex: 0,
        },
      ];

    },
    onChange(picker, item, index) {
      if (index == 0) {
        this.cityCode = item[0].id;
        this.getCommunityList(picker);
      }
    },
    onConfirm(item) {
      this.communityName = item[1].name;
      this.communityId = item[1].id;
      this.showPopup = false;
    },
    getCityList() {
      axios.get("/common/getcitylist?proviceId=410000").then((res) => {
        this.cityList = res.data;
        this.cityCode = res.data[0].id
        this.getCommunityList();
      })
    },
    getCommunityList(picker) {
      axios.post("/common/getcommunitylistbycitycode", {
        cityCode: this.cityCode,
      }).then((res) => {
        if (res.data.length > 0) {
          res.data.forEach(item => {
            item.name = item.communityName
            item.id = item.communityId
          })
        }
        this.communityList = res.data;
        if (picker) {
          picker.setColumnValues(1, res.data);
        }

      })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    async setQRInfo() {
      if (!this.location) {
        Toast("请输入设备位置");
        return;
      }
      Toast.loading({
        duration: 0,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '激活中...'
      });
      //新设备直接激活
      let userinfoRes = await axios.get("/auth/cancreatedevice");
      if (userinfoRes && userinfoRes.data) {
        if (this.mainNo.startsWith("ISC")) {
          //老设备
          let res = await axios.post("/center/setmainnocommunity", {
            mainNo: this.mainNo,
            communityId: this.communityId,
            location: this.location,
          });
          if (res.isSuccess) {
            this.changePage("chargeRule");
            Toast.clear();
          } else {
            Toast(result.message);
          }
        } else {
          let res = await axios.post("/device/create", {
            mainNo: this.mainNo,
            communityId: this.communityId,
            location: this.location,
            type: 2, //默认三轮车
            deviceModel: 2,
          });
          if (res.isSuccess) {
            this.changePage("newDeviceActiveResult");
            Toast.clear();
          } else {
            Toast(result.message);
          }
        }
      } else {
        Toast('账户无设备激活权限');
      }

    },
  },
  computed: {
  },
  created() {
    this.mainNo = this.$route.query.mainNo;
    this.getCityList();
  },
  mounted() { },
  destroyed() { }
}
</script>

<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
  background: #fff
}

.container {
  width: 100%;
  min-height: 100vh;
  letter-spacing: 0px;
  background: #fff;
}

.btnbox {
  margin-top: 200px;
  padding: 0 50px;
}
</style>
